import OneSignal from "react-onesignal";

export const initOneSignal = async () => {
  try {
    if (OneSignal.initialized === true) return;

    await OneSignal.init({
      appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
      safari_web_id: process.env.REACT_APP_ONESIGNAL_SAFARI_WEB_ID,
      allowLocalhostAsSecureOrigin: true,
    });

    console.log("2️⃣ OneSignal init done");
  } catch (err) {
    console.warn("⚠️ OneSignal init failed (unsupported device):", err);
  }
};

export const setOneSignalUser = async (oneSignalUserId) => {
  console.log("3️⃣ setOneSignalUser called with:", oneSignalUserId);

  if (!oneSignalUserId) {
    console.warn("❌ oneSignalUserId is null/undefined — skipping");
    return;
  }

  try {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    await OneSignal.login(oneSignalUserId);
    console.log("✅ OneSignal.login() done");

    await OneSignal.Notifications.requestPermission();
    console.log("✅ Permission request done");
  } catch (err) {
    console.warn("⚠️ OneSignal setUser failed (unsupported device):", err);
  }
};

export const logoutOneSignal = () => {
  try {
    OneSignal.logout();
  } catch (err) {
    console.warn("⚠️ OneSignal logout failed:", err);
  }
};
